import { useEffect, useState } from "react";
import defaultAvatar from "assets/img/avatars/default-avatar.svg";

export const DEFAULT_USER_AVATAR = defaultAvatar as string;

type UserAvatarProps = {
  src?: string | null;
  alt?: string;
  className?: string;
};

function isUsableAvatarUrl(value?: string | null): value is string {
  if (typeof value !== "string") return false;
  const trimmed = value.trim();
  if (!trimmed) return false;
  if (/^(https?:\/\/|data:image\/|blob:)/i.test(trimmed)) return true;
  // Webpack/dev-server local asset paths
  if (trimmed.startsWith("/") || trimmed.startsWith("static/media/")) return true;
  return false;
}

/**
 * Circular user photo with a local default when the URL is missing or fails to load.
 */
export default function UserAvatar({
  src,
  alt = "",
  className = "h-8 w-8 rounded-full object-cover",
}: UserAvatarProps) {
  const [failed, setFailed] = useState(false);
  const usable = isUsableAvatarUrl(src) ? src.trim() : "";

  useEffect(() => {
    setFailed(false);
  }, [usable]);

  const resolved = !failed && usable ? usable : DEFAULT_USER_AVATAR;

  return (
    <img
      src={resolved}
      alt={alt}
      className={className}
      referrerPolicy="no-referrer"
      onError={() => {
        if (resolved !== DEFAULT_USER_AVATAR) setFailed(true);
      }}
    />
  );
}
